export default "__VITE_ASSET__DQq9_34B__"